module.exports = __webpack_public_path__ + "img/rosemount-2051-in-line-pressure-transmitter-1-facing-left.31b862e7.png";